import { ExperimentState } from 'modules/graphql';

export enum SummaryBadgeColors {
  Green = 'Green',
  Blue = 'Blue',
  Grey = 'Grey',
}

export enum BannerCampaignType {
  Blast = 'Blast',
  Triggered = 'Triggered',
}

export enum RandomlySplitVariations {
  False = 'randomlySplitVariations_false',
  True = 'randomlySplitVariations_true',
}

export enum SummaryCardWinner {
  Variant = 'Variant',
  Control = 'Control',
  None = 'None',
}

export const BadgeColor = {
  GREEN: SummaryBadgeColors.Green,
  BLUE: SummaryBadgeColors.Blue,
  GREY: SummaryBadgeColors.Grey,
};

export const experimentDetailsSummaryCardNoWinnerMap = {
  [ExperimentState.CANCELLED]: {
    primaryText: 'experimentSummaryBanner.noWinner.cancelled.primaryText',
    secondaryText: 'experimentSummaryBanner.noWinner.cancelled.secondaryText',
    iconColor: BadgeColor.GREY,
  },
  [ExperimentState.DRAFT]: {
    primaryText: 'experimentSummaryBanner.noWinner.draft.primaryText',
    secondaryText: 'experimentSummaryBanner.noWinner.draft.secondaryText',
    iconColor: BadgeColor.GREY,
  },
  [ExperimentState.ERRORED]: {
    primaryText: 'experimentSummaryBanner.noWinner.errored.primaryText',
    secondaryText: 'experimentSummaryBanner.noWinner.errored.secondaryText',
    iconColor: BadgeColor.GREY,
  },
  [ExperimentState.READY]: {
    primaryText: 'experimentSummaryBanner.noWinner.ready.primaryText',
    secondaryText: 'experimentSummaryBanner.noWinner.ready.secondaryText',
    iconColor: BadgeColor.GREY,
  },
};

export const BLAST_ITERABLE_SELECTED_WINNER = {
  [ExperimentState.RUNNING]: {
    primaryText: 'experimentSummaryBanner.blast.randomlySplitVariations_false.running.primaryText',
    secondaryText:
      'experimentSummaryBanner.blast.randomlySplitVariations_false.running.secondaryText',
    iconColor: BadgeColor.BLUE,
  },
  [ExperimentState.FINISHED]: {
    [SummaryCardWinner.Control]: {
      primaryText:
        'experimentSummaryBanner.blast.randomlySplitVariations_false.finished.control.primaryText',
      secondaryText:
        'experimentSummaryBanner.blast.randomlySplitVariations_false.finished.control.secondaryText',
      iconColor: BadgeColor.GREEN,
    },
    [SummaryCardWinner.Variant]: {
      primaryText:
        'experimentSummaryBanner.blast.randomlySplitVariations_false.finished.variant.primaryText',
      secondaryText:
        'experimentSummaryBanner.blast.randomlySplitVariations_false.finished.variant.secondaryText',
      iconColor: BadgeColor.GREEN,
    },
    [SummaryCardWinner.None]: {
      primaryText:
        'experimentSummaryBanner.blast.randomlySplitVariations_false.finished.none.primaryText',
      secondaryText:
        'experimentSummaryBanner.blast.randomlySplitVariations_false.finished.none.secondaryText',
      iconColor: BadgeColor.GREY,
    },
  },
  [ExperimentState.WINNER_FOUND]: {
    [SummaryCardWinner.Control]: {
      primaryText:
        'experimentSummaryBanner.blast.randomlySplitVariations_false.winnerFound.control.primaryText',
      secondaryText:
        'experimentSummaryBanner.blast.randomlySplitVariations_false.winnerFound.control.secondaryText',
      iconColor: BadgeColor.BLUE,
    },
    [SummaryCardWinner.Variant]: {
      primaryText:
        'experimentSummaryBanner.blast.randomlySplitVariations_false.winnerFound.variant.primaryText',
      secondaryText:
        'experimentSummaryBanner.blast.randomlySplitVariations_false.winnerFound.variant.secondaryText',
      iconColor: BadgeColor.BLUE,
    },
    [SummaryCardWinner.None]: {
      primaryText:
        'experimentSummaryBanner.blast.randomlySplitVariations_false.winnerFound.none.primaryText',
      secondaryText:
        'experimentSummaryBanner.blast.randomlySplitVariations_false.winnerFound.none.secondaryText',
      iconColor: BadgeColor.BLUE,
    },
  },
};

export const TRIGGERED_ITERABLE_SELECTED_WINNER = {
  [ExperimentState.RUNNING]: {
    primaryText:
      'experimentSummaryBanner.triggered.randomlySplitVariations_false.running.primaryText',
    secondaryText:
      'experimentSummaryBanner.triggered.randomlySplitVariations_false.running.secondaryText',
    iconColor: BadgeColor.BLUE,
  },
  [ExperimentState.FINISHED]: {
    [SummaryCardWinner.Control]: {
      primaryText:
        'experimentSummaryBanner.triggered.randomlySplitVariations_false.finished.control.primaryText',
      secondaryText:
        'experimentSummaryBanner.triggered.randomlySplitVariations_false.finished.control.secondaryText',
      iconColor: BadgeColor.GREEN,
    },
    [SummaryCardWinner.Variant]: {
      primaryText:
        'experimentSummaryBanner.triggered.randomlySplitVariations_false.finished.variant.primaryText',
      secondaryText:
        'experimentSummaryBanner.triggered.randomlySplitVariations_false.finished.variant.secondaryText',
      iconColor: BadgeColor.GREEN,
    },
    [SummaryCardWinner.None]: {
      primaryText:
        'experimentSummaryBanner.triggered.randomlySplitVariations_false.finished.none.primaryText',
      secondaryText:
        'experimentSummaryBanner.triggered.randomlySplitVariations_false.finished.none.secondaryText',
      iconColor: BadgeColor.GREY,
    },
  },
  [ExperimentState.WINNER_FOUND]: {
    [SummaryCardWinner.Control]: {
      primaryText:
        'experimentSummaryBanner.triggered.randomlySplitVariations_false.winnerFound.control.primaryText',
      secondaryText:
        'experimentSummaryBanner.triggered.randomlySplitVariations_false.winnerFound.control.secondaryText',
      iconColor: BadgeColor.BLUE,
    },
    [SummaryCardWinner.Variant]: {
      primaryText:
        'experimentSummaryBanner.triggered.randomlySplitVariations_false.winnerFound.variant.primaryText',
      secondaryText:
        'experimentSummaryBanner.triggered.randomlySplitVariations_false.winnerFound.variant.secondaryText',
      iconColor: BadgeColor.BLUE,
    },
    [SummaryCardWinner.None]: {
      primaryText:
        'experimentSummaryBanner.triggered.randomlySplitVariations_false.winnerFound.none.primaryText',
      secondaryText:
        'experimentSummaryBanner.triggered.randomlySplitVariations_false.winnerFound.none.secondaryText',
      iconColor: BadgeColor.BLUE,
    },
  },
};

export const BLAST_NOT_ITERABLE_SELECTED_WINNER = {
  [ExperimentState.RUNNING]: {
    primaryText: 'experimentSummaryBanner.blast.randomlySplitVariations_true.running.primaryText',
    secondaryText:
      'experimentSummaryBanner.blast.randomlySplitVariations_true.running.secondaryText',
    iconColor: BadgeColor.BLUE,
  },
  [ExperimentState.FINISHED]: {
    [SummaryCardWinner.Control]: {
      primaryText:
        'experimentSummaryBanner.blast.randomlySplitVariations_true.finished.control.primaryText',
      secondaryText:
        'experimentSummaryBanner.blast.randomlySplitVariations_true.finished.control.secondaryText',
      iconColor: BadgeColor.GREEN,
    },
    [SummaryCardWinner.Variant]: {
      primaryText:
        'experimentSummaryBanner.blast.randomlySplitVariations_true.finished.variant.primaryText',
      secondaryText:
        'experimentSummaryBanner.blast.randomlySplitVariations_true.finished.variant.secondaryText',
      iconColor: BadgeColor.GREEN,
    },
    [SummaryCardWinner.None]: {
      primaryText:
        'experimentSummaryBanner.blast.randomlySplitVariations_true.finished.none.primaryText',
      secondaryText:
        'experimentSummaryBanner.blast.randomlySplitVariations_true.finished.none.secondaryText',
      iconColor: BadgeColor.GREY,
    },
  },
  [ExperimentState.WINNER_FOUND]: {
    [SummaryCardWinner.Control]: {
      primaryText:
        'experimentSummaryBanner.blast.randomlySplitVariations_true.winnerFound.control.primaryText',
      secondaryText:
        'experimentSummaryBanner.blast.randomlySplitVariations_true.winnerFound.control.secondaryText',
      iconColor: BadgeColor.BLUE,
    },
    [SummaryCardWinner.Variant]: {
      primaryText:
        'experimentSummaryBanner.blast.randomlySplitVariations_true.winnerFound.variant.primaryText',
      secondaryText:
        'experimentSummaryBanner.blast.randomlySplitVariations_true.winnerFound.variant.secondaryText',
      iconColor: BadgeColor.BLUE,
    },
    [SummaryCardWinner.None]: {
      primaryText:
        'experimentSummaryBanner.blast.randomlySplitVariations_true.winnerFound.none.primaryText',
      secondaryText:
        'experimentSummaryBanner.blast.randomlySplitVariations_true.winnerFound.none.secondaryText',
      iconColor: BadgeColor.BLUE,
    },
  },
};

export const TRIGGERED_NOT_ITERABLE_SELECTED_WINNER = {
  [ExperimentState.RUNNING]: {
    primaryText:
      'experimentSummaryBanner.triggered.randomlySplitVariations_true.running.primaryText',
    secondaryText:
      'experimentSummaryBanner.triggered.randomlySplitVariations_true.running.secondaryText',
    iconColor: BadgeColor.BLUE,
  },
  [ExperimentState.FINISHED]: {
    [SummaryCardWinner.Control]: {
      primaryText:
        'experimentSummaryBanner.triggered.randomlySplitVariations_true.finished.control.primaryText',
      secondaryText:
        'experimentSummaryBanner.triggered.randomlySplitVariations_true.finished.control.secondaryText',
      iconColor: BadgeColor.GREEN,
    },
    [SummaryCardWinner.Variant]: {
      primaryText:
        'experimentSummaryBanner.triggered.randomlySplitVariations_true.finished.variant.primaryText',
      secondaryText:
        'experimentSummaryBanner.triggered.randomlySplitVariations_true.finished.variant.secondaryText',
      iconColor: BadgeColor.GREEN,
    },
    [SummaryCardWinner.None]: {
      primaryText:
        'experimentSummaryBanner.triggered.randomlySplitVariations_true.finished.none.primaryText',
      secondaryText:
        'experimentSummaryBanner.triggered.randomlySplitVariations_true.finished.none.secondaryText',
      iconColor: BadgeColor.GREY,
    },
  },
  [ExperimentState.WINNER_FOUND]: {
    [SummaryCardWinner.Control]: {
      primaryText:
        'experimentSummaryBanner.triggered.randomlySplitVariations_true.winnerFound.control.primaryText',
      secondaryText:
        'experimentSummaryBanner.triggered.randomlySplitVariations_true.winnerFound.control.secondaryText',
      iconColor: BadgeColor.BLUE,
    },
    [SummaryCardWinner.Variant]: {
      primaryText:
        'experimentSummaryBanner.triggered.randomlySplitVariations_true.winnerFound.variant.primaryText',
      secondaryText:
        'experimentSummaryBanner.blast.randomlySplitVariations_true.winnerFound.variant.secondaryText',
      iconColor: BadgeColor.BLUE,
    },
    [SummaryCardWinner.None]: {
      primaryText:
        'experimentSummaryBanner.triggered.randomlySplitVariations_true.winnerFound.none.primaryText',
      secondaryText:
        'experimentSummaryBanner.triggered.randomlySplitVariations_true.winnerFound.none.secondaryText',
      iconColor: BadgeColor.BLUE,
    },
  },
};

interface experimentDetailsSummaryCardMapType {
  [key: string]: any;
}

export const experimentDetailsSummaryCardMap: experimentDetailsSummaryCardMapType = {
  [BannerCampaignType.Blast]: {
    [RandomlySplitVariations.False]: {
      ...BLAST_ITERABLE_SELECTED_WINNER,
    },
    [RandomlySplitVariations.True]: {
      ...BLAST_NOT_ITERABLE_SELECTED_WINNER,
    },
  },
  [BannerCampaignType.Triggered]: {
    [RandomlySplitVariations.False]: {
      ...TRIGGERED_ITERABLE_SELECTED_WINNER,
    },
    [RandomlySplitVariations.True]: {
      ...TRIGGERED_NOT_ITERABLE_SELECTED_WINNER,
    },
  },
};

export const trackExperimentBannerState = [
  BLAST_ITERABLE_SELECTED_WINNER[ExperimentState.RUNNING].primaryText,
  TRIGGERED_ITERABLE_SELECTED_WINNER[ExperimentState.WINNER_FOUND][SummaryCardWinner.None]
    .primaryText,
];
